import { FeatureFlags } from './types';

export const prodFeatureFlags: FeatureFlags = {};
